<app-panel-body>
  <div class="flex min-h-0 flex-1 flex-col">
    <div class="min-h-0 flex-1 overflow-y-auto">
      <app-content-container>
        @if (tripId(); as id) {
          <app-trip-link-qr [tripId]="id" copy="image" />
        }
      </app-content-container>
    </div>
  </div>
</app-panel-body>
